<template>
    <div class="gear__item" :class="'gear__item--'+type" v-if="gearDetail">

        <i v-if="gearDetail.verified" v-b-tooltip.hover title="Verified" class="gear__item__verified las la-check"></i>

        <span class="gear__item__options"><slot></slot></span>

        <router-link :to="'/gear/'+gearDetail.id" class="gear__item__content">
            <div class="gear__item__image">
                <GearImage :gearId="gearDetail.id" />
            </div>
            
            {{ gearDetail.brand }} {{ gearDetail.title }}
        </router-link>
        <div class="list__item__actions">
            
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import GearImage from './GearImage.vue'

export default {
    name: "ListItemGear",
    props: ["gearId", "type"],
    computed: {
        ...mapState(["gear"]),
        gearDetail() {
            return this.gear.find(g => g.id === this.gearId);
        }
    },
    methods: {},
    mounted() {
    },
    components: { GearImage }
}
</script>